import {
  IRecognitionCreateProps,
  IRecognitionProps,
  IRecognitionSimpleProps,
  IRecognitionUpdateProps,
} from '../types';
import { IIntegrationProps } from '../../IntegrationService/types';

export interface IStudentRecognitionProps extends IRecognitionProps {
  birthDate: Date;
  gender: StudentGenderTypes;
  registration: string;
  integrations: IIntegrationProps[];
  canGoOut?: boolean;
  responsibleIds: number[];
  cards?: string[] | null;
  uc?: string[] | null;
}

export interface IStudentRecognitionSimpleProps
  extends IRecognitionSimpleProps {
  birthDate: Date;
  registration: string;
  gender: StudentGenderTypes;
  canGoOut?: boolean;
  cards?: string[] | null;
  uc?: string[] | null;
}

export interface IStudentRecognitionCreateProps
  extends IRecognitionCreateProps {
  birthDate: string;
  gender: string;
  registration: string;
  responsibleIds: number[];
  cards?: string[] | null;
  uc?: string[] | null;
}

export interface IStudentRecognitionUpdateProps
  extends IRecognitionUpdateProps {
  birthDate: string;
  registration: string;
  gender: string;
  responsibleIds: number[];
  cards?: string[] | null;
  uc?: string[] | null;
}

export interface IStudentRecognitionUpdateParams {
  id: number;
  data: IStudentRecognitionUpdateProps;
}

export enum StudentGenderTypes {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}
